import { useState } from 'react';
import { connect } from 'react-redux';
import { publishTesScores } from './redux/reduxApi';
import { closeModal } from '../../../app/modals/redux/modalActions';
import useScreenWidth from '../../../app/common/helpers/useScreenWidth';
import Modal from '../../../ui/Modal';
import Button from '../../../ui/Button';
import Icon from '@mdi/react';
import { mdiBell } from '@mdi/js';

const actions = {
  closeModal,
  publishTesScores,
};

function ModalPublishScore({ publishTesScores, data, closeModal }) {
  const auth = data?.auth;
  const item = data?.item;
  const title = data?.title;
  const pelajaran = data?.pelajaran;
  const id = data?.id;
  const history = data?.history;
  const screenWidth = useScreenWidth();
  const [checked, setChecked] = useState(false);
  const notifMessage = `Nilai tugas "${title}" pelajaran ${pelajaran} telah dipublish. Nilai kamu adalah`;

  function handlePublish() {
    publishTesScores({
      auth,
      history,
      id,
      values: item,
      notifMessage: checked ? notifMessage : null,
    });
    closeModal();
  }

  function handleOncheck() {
    setChecked(!checked);
  }

  return (
    <Modal
      variant='info'
      label='Publish'
      closeModal={closeModal}
      width={screenWidth > 600 ? 600 : screenWidth}
    >
      <div className='flex justify-around flex-column align-start mt-5 mx-5'>
        <p className='is-size-6 mt-5 mb-3'>
          Apakah Anda yakin untuk mempublish score siswa?
        </p>
        <ol style={{ fontSize: 14, marginLeft: 16 }}>
          <li>Nilai yang akan dipublish adalah Nilai Akhir.</li>
          <li>Setelah dipublish siswa akan bisa melihat scorenya.</li>
        </ol>
        <div
          className='mt-2 notification is-info is-size-7'
          style={{ visibility: checked ? 'visible' : 'hidden', padding: '4px 8px' }}
        >
          <div>
            <span className='icon is-small'>
              <Icon path={mdiBell} size={0.4} />
            </span>
            Preview Notif:
          </div>
          <div className='ml-4'>
            {`${notifMessage} "__"`}
          </div>
        </div>
      </div>
      <div className='flex justify-between align-center px-4'>
        <div className='field ml-2'>
          <div className='control'>
            <label className='custom-checkbox'>
              Kirim Notifikasi
              {!checked && <input type='checkbox' onChange={handleOncheck} />}
              {checked && (
                <input checked type='checkbox' onChange={handleOncheck} />
              )}
              <span className='checkmark' />
            </label>
          </div>
        </div>
        <div className='buttons'>
          <Button cvariant='csave' onClick={() => handlePublish(data)} />
          <Button cvariant='cback' onClick={closeModal} />
        </div>
      </div>
    </Modal>
  );
}

export default connect(null, actions)(ModalPublishScore);
